/**
 * AccessControl entity model class
 *
 * This file is part of ePlan
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import dayjs, { Dayjs } from 'dayjs';

export const AC_MODES = {
    MODE_READ: 'r',
    MODE_READ_PUBLICATION: 'rp',
    MODE_READ_RESTRICTED: 'r-',
    MODE_READ_WRITE: 'rw',
};

export const AC_CREATION_LEVEL = {
    CREATION_LEVEL_USER: 'user',
    CREATION_LEVEL_GEMEINDE: 'gemeinde',
    CREATION_LEVEL_SYSTEM: 'system',
};

export class AccessControl extends BaseModel {
    public id: number | null = null;
    public created: Dayjs | null = null;    
    public user_id: number | null = null;
    public stelle_id: number | null = null;
    public planning_permission_application_id: number | null = null;    
    public mode: string | null = null;
    public locked: boolean | null = null;
    public user_visible: boolean | null = null;
    public comment: string | null = null;
    public creation_level: string | null = null;
    public accepted: Dayjs | null = null; 

    // View
    public username: string | null = null;
    public email: string | null = null;
    public name: string | null = null;
    public planning_permission_application_creator_id: number | null = null;

    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            parent_id: (id) => (Number(id) > 0 ? Number(id) : null),
            creator_id: (id) => (Number(id) > 0 ? Number(id) : null),
            created: (value) => dayjs(value),
            accepted: (value) => dayjs(value)
        };
    }

    getClassName() {
        return 'AccessControl';
    }
}

export class AccessControlCollection extends BaseCollection<AccessControl> {
    protected modelCls = AccessControl;

    public getModelClassName(): string {
        return 'AccessControl';
    }
}
